import { memo, useMemo } from 'react';
import { Advice, Modal } from '@Sage/hoi-poi-ui';
import { getLiteral, getLiteralWithParametersHtml } from 'utils/getLiteral';

const WarningDependencyModal = memo(({ parentField, dependantFields, onClose, schema }) => {
    const modalProps = useMemo(() => {
        const adviceProps = {
            type: 'semanticFocus',
            showIcon: true,
            showCollapse: false,
            children: getLiteralWithParametersHtml(
                'label_massive_update_dependant_fields_cant_undone',
                [parentField, dependantFields],
                (param) => {
                    if (typeof param === 'string') {
                        return <strong>{param}</strong>;
                    }
                    if (Array.isArray(param) && param.length > 0) {
                        return param.length === 1
                            ? [<strong key={param[0]}>{param[0]}</strong>, '.']
                            : param
                                  .map((item) => <strong key={item}>{item}</strong>)
                                  .reduce((prev, curr) => [prev, ', ', curr])
                                  .concat('.');
                    }
                    return param;
                },
            ),
        };

        return {
            className: 'fm-warning-dependency-modal',
            title: getLiteral('label_parent_field'),
            isOpen: dependantFields?.length > 0,
            onRequestClose: onClose,
            onConfirm: onClose,
            confirmText: getLiteral('action_close'),
            children: <Advice {...adviceProps} />,
        };
    }, [dependantFields, onClose, parentField]);

    return <Modal {...modalProps} />;
});

export default WarningDependencyModal;
